import ValidateService from '../services/ValidateService';
import { nameValidateProps, phoneValidateProps } from "../services/ValidateService";
import { attachEmailSuggestion } from "../services/EmailProviderValidator";
import '../../../assets/js/jquery.flexdatalist.min';
import { Fancybox } from "@fancyapps/ui";

class FormBett2026Auto{

    static init(){

        if (!$('.block-lead-form-bett-2026-auto').length) return;

        var cidadesflex = false;
        let jsonEstadosCidades;
        var current_fs, next_fs, previous_fs;
        var opacity;
        var sendingPendingData = false;

        const form = $('#msform');

        const formOptions = {
            form,
            modalMessage: true,
            rules: {
              ...nameValidateProps.rules,
              ...phoneValidateProps.rules
            },
            messages: {
              ...nameValidateProps.messages,
              ...phoneValidateProps.messages,
            }
        }

        const validateForm = new ValidateService( formOptions );
        validateForm.validate();

        var validator = form.validate();

        const emailSuggestionGuard = attachEmailSuggestion(
            document.getElementById('leads-email'),
            document.getElementById('leads-email-suggestion')
        );

        $( window ).off('load').on( "load", function(){

            if ($('.block-lead-form-bett-2026-auto').length){
                $(".nld-chatbot").remove();
                $("header").remove();
            }

            $.getJSON( '/wp-content/themes/portalEdify/src/js/json/cidades.json', function (data) {

                $("#cidades").flexdatalist({
                    minLength: 0,
                    valueProperty: '*',
                    selectionRequired: true,
                    visibleProperties: ["cidade"],
                    searchIn: 'cidade',
                    data: data,
                    searchContain: true,
                    cache: false,
                });

            });

            $.getJSON( '/wp-content/themes/portalEdify/src/js/json/estados_cidades.json', function (data) {

                jsonEstadosCidades = data;

                var estados_obj = [];
                var j = 0;
                $.each(data, function (key, val) {
                    j++;
                    estados_obj.push( { id: j, name: val.nome, sigla: val.sigla } );
                });

                $('#estados').flexdatalist({
                    selectionRequired: 1,
                    minLength: 0,
                    valueProperty: ["sigla"],
                    visibleProperties: ["name"],
                    searchIn: 'name',
                    data: estados_obj,
                    searchContain: true,
                    cache: false,
                });

            });

        } );

        $(document).on('focusin',"input[name='flexdatalist-estados'], input[name='flexdatalist-cidades']", function(){
            $("#" + $(this).attr('id').split('-')[0]).flexdatalist('value', '');
        });

        $(document).on('focusout',"input[name='flexdatalist-estados'], input[name='flexdatalist-cidades']", function(){
            var id = $(this).attr('id').split('-')[0];
            if( ! $("#" + id).val().length ){
                $(this).val('');
                if( id == "estados"){
                    if(cidadesflex){
                        cidadesflex.flexdatalist('disabled', true);
                        $("#cidades").flexdatalist('value', '')
                    }
                }
            }
        });

        $(".next").off('click').on('click', function(event){

            if( validator.form() ){

                if( emailSuggestionGuard.isBlocked() && $(this).parent().find('#leads-email').length ){
                    emailSuggestionGuard.focusInput();
                    return;
                }

                $('#ja-fez-reuniao').prop('checked', false);
                current_fs = $(this).parent();
                next_fs = $(this).parent().next();

                next_fs.show();

                current_fs.animate({opacity: 0}, {
                    step: function(now) {
                        opacity = 1 - now;

                        current_fs.css({
                            'display': 'none',
                            'position': 'relative'
                        });
                        next_fs.css({'opacity': opacity});
                    },
                    duration: 600
                });

                window.scrollTo(0, 0);

            }

        });

        var ja_fez_reuniao_antes = false;
        $("#ja-fez-reuniao").change(function(){
            ja_fez_reuniao_antes = $('#ja-fez-reuniao').is(":checked");
        });

        $(".previous").click(function(){

            current_fs = $(this).parent();
            previous_fs = $(this).parent().prev();

            previous_fs.show();

            current_fs.animate({opacity: 0}, {
                step: function(now) {
                    opacity = 1 - now;

                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    previous_fs.css({'opacity': opacity});
                },
                duration: 600
            });

            window.scrollTo(0, 0);
        });

        const isProfessorCargo = () => {
            const cargo = $("#leads-cargo").val();
            return cargo && cargo.toLowerCase().indexOf("professor") !== -1;
        };

        const updateEscolaPerfilFields = () => {
            const perfil = $("#leads-escola-perfil").val();

            if( perfil == "Outro" ){
                $(".dados-se-escola").addClass('d-none');
            }else if( perfil == "Privada" && !isProfessorCargo() ){
                $(".dados-se-escola").removeClass('d-none');
                $("#dados-se-escola-privada").removeClass('d-none');
            }else{
                $(".dados-se-escola").removeClass('d-none');
                $("#dados-se-escola-privada").addClass('d-none');
            }
        };

        $("#leads-escola-perfil").change(updateEscolaPerfilFields);

        $("#leads-cargo").change(updateEscolaPerfilFields);

        $("#possui-bilingue").change(function(){
            if($(this).val() == "Sim"){
                $("#dados-se-possui-programa-bilingue").removeClass('d-none');
            }else{
                $("#dados-se-possui-programa-bilingue").addClass('d-none');
            }
        });

        const checkInternetConnection = () => {
            return new Promise((resolve) => {
                const timeoutDuration = 1500;
                const timestamp = new Date().getTime();

                const endpoints = [
                    'https://www.google.com/generate_204?_=' + timestamp
                ];

                let successCount = 0;
                let completedRequests = 0;
                let resolved = false;

                const safeResolve = (value) => {
                    if (!resolved) {
                        resolved = true;
                        resolve(value);
                    }
                };

                const checkCompletion = () => {
                    completedRequests++;

                    if (successCount > 0) {
                        safeResolve(true);
                    } else if (completedRequests >= endpoints.length) {
                        safeResolve(false);
                    }
                };

                const generalTimeout = setTimeout(() => {
                    if (!resolved) {
                        safeResolve(false);
                    }
                }, timeoutDuration * 1.5);

                endpoints.forEach((url, index) => {
                    const timeout = setTimeout(() => {
                        checkCompletion();
                    }, timeoutDuration);

                    fetch(url, {
                        method: 'HEAD',
                        cache: 'no-store',
                        headers: { 'Cache-Control': 'no-cache' },
                        mode: url.includes(window.location.origin) ? 'same-origin' : 'no-cors'
                    })
                    .then(response => {
                        clearTimeout(timeout);
                        if (response.ok || response.status === 0 || response.type === 'opaque') {
                            successCount++;
                        }
                        checkCompletion();
                    })
                    .catch(() => {
                        clearTimeout(timeout);
                        checkCompletion();
                    });
                });

                return () => {
                    clearTimeout(generalTimeout);
                };
            });
        };

        const updatePendingFormsCounter = () => {
            try {
                const savedData = JSON.parse(localStorage.getItem('offlineFormData') || '[]');
                const pendingForms = savedData.filter(item => item.syncStatus === 'pending');
                const pendingCount = pendingForms.length;

                $("#pending-forms-count").text(pendingCount);

                if (pendingCount > 0) {
                    $("#pending-forms-indicator").show().addClass('has-pending');
                } else {
                    $("#pending-forms-indicator").hide().removeClass('has-pending');
                }

                return pendingCount;
            } catch (error) {
                return 0;
            }
        };

        const checkPendingData = () => {
            try {
                const savedData = JSON.parse(localStorage.getItem('offlineFormData') || '[]');
                return savedData.filter(item => item.syncStatus === 'pending');
            } catch (error) {
                return [];
            }
        };

        const saveFormDataOffline = (formData) => {
            try {
                const savedData = JSON.parse(localStorage.getItem('offlineFormData') || '[]');

                formData.timestamp = new Date().toISOString();
                formData.syncStatus = 'pending';

                savedData.push(formData);

                localStorage.setItem('offlineFormData', JSON.stringify(savedData));

                updatePendingFormsCounter();

                return true;
            } catch (error) {
                return false;
            }
        };

        const sendPendingData = () => {

            if (sendingPendingData) return;
            sendingPendingData = true;

            try {
                const savedData = JSON.parse(localStorage.getItem('offlineFormData') || '[]');
                const updatedData = [...savedData];
                let pendingItemsCount = 0;

                for (let i = 0; i < savedData.length; i++) {
                    if (savedData[i].syncStatus === 'pending') {
                        pendingItemsCount++;
                    }
                }

                if (pendingItemsCount === 0) {
                    sendingPendingData = false;
                    return;
                }

                for (let index = 0; index < savedData.length; index++) {
                    if (savedData[index].syncStatus === 'pending') {
                        updatedData[index].syncStatus = 'processing';
                        localStorage.setItem('offlineFormData', JSON.stringify(updatedData));

                        $.ajax({
                            url: "https://api-edify-marketing.edifyeducation.com.br/api/rd-marketing/create-conversion?api_key=6XgKgTk2X4OVd8etgN0ilh",
                            method: "POST",
                            data: savedData[index],
                            success: function() {
                                const currentData = JSON.parse(localStorage.getItem('offlineFormData') || '[]');
                                currentData[index].syncStatus = 'synced';
                                localStorage.setItem('offlineFormData', JSON.stringify(currentData));

                                updatePendingFormsCounter();

                                sendingPendingData = false;

                                setTimeout(() => {
                                    const remainingPending = checkPendingData();
                                    if (remainingPending.length > 0) {
                                        sendPendingData();
                                    }
                                }, 500);
                            },
                            error: function() {
                                const currentData = JSON.parse(localStorage.getItem('offlineFormData') || '[]');
                                currentData[index].syncStatus = 'pending';
                                localStorage.setItem('offlineFormData', JSON.stringify(currentData));

                                sendingPendingData = false;
                            }
                        });

                        break;
                    }
                }
            } catch (error) {
                sendingPendingData = false;
            }
        };

        const monitorInternetConnection = () => {

            let lastConnectionStatus = null;
            let consecutiveFailures = 0;
            let consecutiveSuccesses = 0;
            let intervalId = null;
            let isCheckingNow = false;
            let lastSyncTime = 0;

            const checkConnection = async () => {

                if (isCheckingNow) return;

                isCheckingNow = true;

                try {

                    const isOnline = await checkInternetConnection();

                    if (isOnline) {
                        consecutiveSuccesses++;
                        consecutiveFailures = 0;
                    } else {
                        consecutiveFailures++;
                        consecutiveSuccesses = 0;
                    }

                    const confirmedOffline = consecutiveFailures >= 2;
                    const confirmedOnline = consecutiveSuccesses >= 1;

                    if (lastConnectionStatus === false && confirmedOnline) {

                        const now = Date.now();
                        if (now - lastSyncTime > 5000) {
                            const pendingData = checkPendingData();
                            if (pendingData.length > 0 && !sendingPendingData) {
                                lastSyncTime = now;
                                sendPendingData();
                            }
                        }

                        lastConnectionStatus = true;
                    }
                    else if (lastConnectionStatus === true && confirmedOffline) {
                        lastConnectionStatus = false;
                    }
                    else if (lastConnectionStatus === null) {
                        lastConnectionStatus = confirmedOnline;

                        if (confirmedOnline) {
                            const pendingData = checkPendingData();
                            if (pendingData.length > 0 && !sendingPendingData) {
                                lastSyncTime = Date.now();
                                sendPendingData();
                            }
                        }
                    }

                } catch (error) {
                } finally {
                    isCheckingNow = false;
                }
            };

            if (intervalId) {
                clearInterval(intervalId);
            }

            checkConnection();

            intervalId = setInterval(checkConnection, 10000);

            $(window).on('beforeunload', function() {
                if (intervalId) {
                    clearInterval(intervalId);
                }
            });

            return {
                stop: function() {
                    if (intervalId) {
                        clearInterval(intervalId);
                        intervalId = null;
                    }
                },
                start: function() {
                    if (!intervalId) {
                        checkConnection();
                        intervalId = setInterval(checkConnection, 2000);
                    }
                },
                forceCheck: function() {
                    if (!isCheckingNow) {
                        checkConnection();
                    }
                }
            };
        };

        const connectionMonitor = monitorInternetConnection();

        $(document).ready(function() {
            if (connectionMonitor) {
                connectionMonitor.start();
            }
            updatePendingFormsCounter();
        });

        $("#submit").off('click').on('click', async function() {

            if ($(this).data('processing')) return false;

            if (!validator.form()) return false;

            if (emailSuggestionGuard.isBlocked()) {
                emailSuggestionGuard.focusInput();
                return false;
            }

            const perfilEscola = $("#leads-escola-perfil").val();
            if (perfilEscola && perfilEscola !== "Outros" && !$("#leads-escola-inep-free-flexdatalist").val()) {
                alert("Informe o nome da escola (organização).");
                $("#leads-escola-inep-free-flexdatalist").trigger('focus');
                return false;
            }

            $(this).data('processing', true);
            $(this).addClass('disabled').css('opacity', '0.7');

            const isOnline = await checkInternetConnection();

            if (!isOnline) {

                const data = get_form_data();
                const saved = saveFormDataOffline(data);

                if (saved) {
                    Fancybox.show(
                        [
                          {
                            src: `<ion-icon class="i-size-3 text-danger mb-2" name="alert-circle-outline"></ion-icon><h3 class="h4 text-danger">Atenção</h3><p class="font-size-lg">Você está offline. Os dados serão armazenados localmente e enviados quando houver conexão com a internet.</p>`,
                            type: "html",
                          },
                        ],
                        {
                          mainClass: "form-message-wrapper",
                        }
                    );

                    current_fs = $(this).parent();
                    next_fs = $(this).parent().next();

                    next_fs.show();

                    current_fs.animate({ opacity: 0 }, {
                        step: function(now) {
                            opacity = 1 - now;

                            current_fs.css({
                                'display': 'none',
                                'position': 'relative'
                            });
                            next_fs.css({ 'opacity': opacity });
                        },
                        duration: 600
                    });

                    window.scrollTo(0, 0);
                } else {
                    alert("Erro ao salvar os dados localmente. Por favor, tente novamente quando estiver online.");
                }

                setTimeout(() => {
                    $(this).data('processing', false);
                    $(this).removeClass('disabled').css('opacity', '1');
                }, 650);

                return;
            }

            const data = get_form_data();

            $.ajax({
                url: "https://api-edify-marketing.edifyeducation.com.br/api/rd-marketing/create-conversion?api_key=6XgKgTk2X4OVd8etgN0ilh",
                method: "POST",
                data: data,
                success: function() {
                    current_fs = $("#submit").parent();
                    next_fs = $("#submit").parent().next();

                    next_fs.show();

                    current_fs.animate({opacity: 0}, {
                        step: function(now) {
                            opacity = 1 - now;

                            current_fs.css({
                                'display': 'none',
                                'position': 'relative'
                            });
                            next_fs.css({'opacity': opacity});
                        },
                        duration: 600
                    });

                    window.scrollTo(0, 0);

                    $("#submit").data('processing', false);
                    $("#submit").removeClass('disabled').css('opacity', '1');
                },
                error: function(error) {
                    console.error("Erro ao enviar dados:", error);
                    alert("Ocorreu um erro ao enviar os dados. Por favor, tente novamente.");

                    $("#submit").data('processing', false);
                    $("#submit").removeClass('disabled').css('opacity', '1');
                }
            });
        });

        const get_form_data = () => {

            var uf;
            try {
                uf = JSON.parse($("#estados").val()).sigla;
            } catch(e) {
                uf = "";
            }

            var data = {
                conversion_identifier: nome_evento,
                email: $("#leads-email").val(),
                cf_tipo_cadastro_bett: 'lead',
                name: $("#leads-nome").val(),
                personal_phone: $("#leads-telefone").val(),
                cf_cargo_do_lead: $("#leads-cargo").val(),
                cf_bett_ja_fez_reuniao_comercial_antes: ja_fez_reuniao_antes ? 'sim' : 'não'
            };

            if($("#leads-escola-perfil").val() != "Outros") {
                ($("#leads-alunos-qtd").val()) ? data.cf_quantos_alunos_tem_a_sua_escola = $("#leads-alunos-qtd").val() : '';
                ($("#cidades-flexdatalist").val()) ? data.city = $("#cidades-flexdatalist").val() : '';
                ($("#leads-escola-perfil").val()) ? data.cf_perfil_da_escola = $("#leads-escola-perfil").val() : '';
                ($("#leads-escola-inep-free-flexdatalist").val()) ? data.cf_nome_da_escola = $("#leads-escola-inep-free-flexdatalist").val() : '';
                (uf) ? data.state = uf : '';
            }

            if($("#leads-escola-perfil").val() == "Privada" && !isProfessorCargo()) {
                data.cf_escola_sua_escola_ja_tem_um_programa_bilingue_bett_2 = $("#possui-bilingue").val();
                data.cf_qual_e_a_mensalidade_da_sua_escola = $("#mensalidade-media").val();
            }

            if($("#possui-bilingue").val() == "Sim" && $("#leads-escola-perfil").val() == "Privada" && !isProfessorCargo()) {
                data.cf_escola_nome_do_programa_bilingue_bett_2023 = $("#nome-programa-bilingue").val();
            }

            return data;

        }

        // De volta ao primeiro fieldset (Dados Pessoais): 2 prev() — comerciais → pessoais
        $("#novo-cadastro").click(function(){

            $(".form-group-perfil-organizacao").removeClass('d-none');

            $(".dados-se-escola").addClass('d-none');

            $('form :input:not(:button)').val('');
            $('#meuCheckbox').prop('checked', false);

            current_fs = $(this).parent();
            previous_fs = $(this).parent().prev().prev();

            previous_fs.show();

            current_fs.animate({opacity: 0}, {
                step: function(now) {
                    opacity = 1 - now;

                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    previous_fs.css({'opacity': opacity});
                },
                duration: 600
            });

            $("#submit").css({
                'display': 'initial',
                'opacity': 1,
            });
            $("#submit-previous").css({
                'display': 'initial',
                'opacity': 1,
            });

        })

    }
}

FormBett2026Auto.init();
